/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as UnitService} from "../../../Services/UnitService";
import React from "react";
import {useFormattedValue} from "../../../Hooks/FormatterHooks";
import {EmptyValue} from "../../../Components/Common/EmptyValue";
import {InputGroup} from "react-bootstrap";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";

export const UnitNumberFieldViewer = (props) => {
	
	const {Value: value, FieldDef: fieldDef = {}} = props;
	const {customData = {}} = fieldDef;
	const {
		unitId = props?.unitId ?? -1,
		maximumFractionDigits = 0,
		minimumFractionDigits = 0,
		suffix = null,
		customFormatter = null,
		className = ""
	} = customData;
	
	usePrimeCache([UnitService]);
	
	const unit = UnitService.CachedValueById(unitId)?.result;
	const unsignedUnits = ['acre'];
	const canBeNegative = !unsignedUnits.includes(unit?.name);
	
	const formattedValue = useFormattedValue(value, {
		maximumFractionDigits,
		minimumFractionDigits,
		canBeNegative,
		customFormatter,
	});
	
	let isPrefix = unit?.isPrefix ?? false;
	let unitLabel = unit?.abbreviation ?? suffix;

	if((value ?? '') === '') {
		return <EmptyValue/>;
	}
	
	return <div className={className}>
		{!!isPrefix && unitLabel}
		{' '}
		{formattedValue}
		{' '}
		{!isPrefix && unitLabel}
	</div>;
}
